import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '@core/interfaces/root-state';
import { SelectState } from '@core/interfaces/select-state';

import {
  getters as abstract_getters,
  actions as abstract_actions,
  mutations as abstract_mutations,
} from '@core/store/abstract-provider.store';

const state: SelectState = {
  models: {},
  // extends with new prop and methods here
};
const getters: GetterTree<SelectState, RootState> = {
  ...abstract_getters,
  // extends with new prop and methods here
};
const actions: ActionTree<SelectState, RootState> = {
  ...abstract_actions,
  // extends with new prop and methods here
};
const mutations: MutationTree<SelectState> = {
  ...abstract_mutations,
  // extends with new prop and methods here
};

export const SelectStoreModule: Module<SelectState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
